import React from 'react';
import { DEBUG_LABEL_OTHER_ROOMS } from 'arbitrip-common/client/utils/HotelDealsRm3';

import Rm3DealRow from './Rm3DealRow';

/**
 * DEBUG ONLY (spec §3.6, Q25): deals without RM3 data, framed in the theme error colour. Never rendered for a
 * customer, never ribboned, no photos/specs, no payment split; the heading is an untranslated debug constant.
 */
function Rm3DebugOtherRooms({ otherRooms, displayOrder, context }) {
    return (
        <div className="rm3-debug-other-rooms" data-testid="rm3-debug-other-rooms">
            <div className="rm3-debug-other-rooms__title">{DEBUG_LABEL_OTHER_ROOMS}</div>
            <div className="rm3-card__deals">
                {otherRooms.deals.map((deal) => (
                    <React.Fragment key={deal.id}>
                        <div className="rm3-debug-other-rooms__deal-name">
                            <bdi>{deal.description || ''}</bdi>
                        </div>
                        <Rm3DealRow
                            deal={deal}
                            ribbon={null}
                            roomName={deal.description || ''}
                            displayedOrder={displayOrder.get(deal.id)}
                            context={context}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}

export default Rm3DebugOtherRooms;
